export default __webpack_public_path__ + "static/generative-border-light-33926878f952570c0bf7983f3c787d2b.png";